import * as Yup from "yup";
import { RoleId, RoleAuthorityOrder, canRoleAManageRoleB } from "../enums/Role";
import { FormGroup } from "../../components/form";

export const userForm = (requesterRoleId: RoleId): FormGroup => {
  return {
    type: "formGroup",
    disabledExpression: (context, values) => !canRoleAManageRoleB(requesterRoleId, values.roleId),
    fields: [
      {
        type: "field",
        key: "userEmail",
        fieldType: "input",
        label: "Email",
        validation: Yup.string()
          .trim()
          .required("Email is required")
          .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Invalid email address"),
        expressionProps: {
          disabled: (context, values) => {
            return values.dateCreated != null;
          },
        },
      },
      {
        type: "field",
        key: "displayName",
        fieldType: "input",
        label: "Display name",
        validation: Yup.string().trim().required("Display name is required"),
      },
      {
        type: "field",
        key: "roleType",
        fieldType: "dropdown",
        label: "Role",
        validation: Yup.number().required("Role is required"),
        props: {
          // Disable if role is lower than role option
          options: RoleDropdown.map((o) => (!canRoleAManageRoleB(requesterRoleId, o.value) ? { ...o, disabled: true } : { ...o, disabled: false })),
        },
      },
      {
        type: "field",
        key: "inviteRedirectUrl",
        fieldType: "value",
        defaultValue: import.meta.env.VITE_POSTLOGOUTREDIRECTURI,
        label: "Display name",
      },
      {
        type: "field",
        key: "editUserExplanationPrivilege",
        fieldType: "advisory",
        props: {
          type: "mt-5 font-bold",
        },
        label: "You cannot modify a user with more privilege than your own",
        hideExpression: (context, values) => canRoleAManageRoleB(requesterRoleId, values.roleId),
      },
    ],
  };
};

// e.g.
// {
//   {
//     label: "Root",
//     value: 1,
//     disabled: false,
//   },
//   ...
// }
const RoleDropdown = [...RoleAuthorityOrder].reverse().map((role) => {
  return { label: RoleId[role], value: role, disabled: false };
});
